import Button from "components/button";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Modalheader from "components/modal/components/header";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import Yousign from "hooks/yousign";
import ApiDatabase from "server";

const ModalSignature = () => {
  const { refreshLoadUser } = UseContext();
  const { toggle } = useModal();
  const { dataYousign, signatureLink } = UseContext();

  const yousignInit = () => {
    const yousign = new Yousign({
      signatureLink: signatureLink,
      iframeContainerId: "iframe-container",
      isSandbox: true, // To set if you use the sandbox environment
    });

    yousign.onSuccess((data) => {
      console.log("Signer has successfully signed");
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toggle();
    ApiDatabase.putStatusContract(
      { contract: dataYousign },
      (data) => {
        if (data.success) {
          window.location.reload(false);
          toggle();
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  return (
    <>
      <Modalheader hide={handleSubmit} hideShow={true}>
        Signature du document
      </Modalheader>
      <ModalBody>
        <iframe
          id={"iframe-container"}
          className={"w-full h-[700px]"}
          src={`${signatureLink}&disable_domain_validation=true`}
          onLoad={yousignInit}
        ></iframe>
      </ModalBody>
      <ModalFooter>
        <Button size={"LG"} color={"SECONDARY"} onClick={handleSubmit}>
          Fermer
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalSignature;
